<template>
    <div class="card">
        <div class="card-header">
            {{ titulo }}
        </div>
        <ul class="list-group">
            <li class="list-group-item" v-for="(item, isx) in lista" :key="isx">
                <div class="d-flex justify-content-between">
                    <div>
                        {{ item.descricao }}
                    </div>
                    <div>
                        {{ item.qtde }}
                    </div>
                </div>
                <div>
                    <div class="small text-muted">
                        Mais antiga: 
                        {{ $util.getFormatDate(item.mais_antiga) }}
                        <span class="ml-3">
                            {{ getHumanDuration(item.mais_antiga) }}
                        </span>
                    </div>
                    
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" :style="'width: ' + percentual(item, lista) + '%'"></div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-flex justify-content-between">
                <div>
                    Total
                </div>
                <div>
                    {{ total(lista) }}
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import _ from 'lodash';
import * as moment from 'moment';

export default {
    props: ['titulo', 'lista'], 

    methods: { 
        getHumanDuration (date) {  
            let end = moment().startOf('day');
            let base = date.substr (0,10);
            
            if ( base == this.$util.hoje() ) 
                return 'hoje';
            else
                return 'há ' + moment(end, 'YYYY-MM-DD').diff(base, 'days') + ' dia(s)';
        },

        total (lista) { 
            return _.sumBy(lista, 'qtde');
        },

        percentual(item, lista) { 
            return Math.round((item.qtde / this.total(lista)) * 100);
        },
    }
}
</script>